export default [
    {
        path: '/product-data/project/list/:filter?',
        name: 'product_data_project_list',
        component: () => import('@src/product-data/project/pim-project-list'),
        meta: {
            title: 'Projekte',
            role: 'ROLE_LIST_PIM_PROJECT',
        },
    },
    {
        path: '/product-data/product-import/list/:filter?',
        name: 'product_data_product_import_list',
        component: () => import('@src/product-data/pim/pim-import-list'),
        meta: {
            title: 'Import',
            role: 'ROLE_LIST_PIM_IMPORT',
        },
    },
    {
        path: '/product-data/product-import/create/:selectionData?',
        name: 'product_data_product_import_create',
        component: () => import('@src/product-data/pim/pim-import-create'),
        meta: {
            title: 'Import erstellen',
            role: 'ROLE_EDIT_PIM_IMPORT',
        },
        props(route) {
            const props = { ...route.params };
            if (props.hasOwnProperty('selectionData') && props.selectionData !== null && props.selectionData.length > 0) {
                props.selectionData = JSON.parse(props.selectionData);
            } else {
                delete props.selectionData;
            }
            return props;
        },
    },
    {
        path: '/product-data/product-import/edit/:id/:tab?',
        name: 'product_data_product_import_edit',
        component: () => import('@src/product-data/pim/pim-import-edit'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);
            return props;
        },
        meta: {
            title: 'Import bearbeiten',
            role: 'ROLE_EDIT_PIM_IMPORT',
        },
    },
    {
        path: '/product-data/product-import/edit-core-data-only/:id',
        name: 'product_data_product_import_edit_core_data_only',
        component: () => import('@src/product-data/pim/pim-import-edit-core-data-only'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);
            return props;
        },
        meta: {
            title: 'Import bearbeiten (nur Stammdaten)',
            role: 'ROLE_EDIT_PIM_IMPORT',
        },
    },
    {
        path: '/product-data/product-import/select-products/:selectedFileName?',
        name: 'product_data_select_products',
        component: () => import('@src/product-data/pim/select-products'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Produkte auswählen',
            role: 'ROLE_EDIT_PIM_IMPORT',
        },
    },
    {
        path: '/product-data/damaged-products',
        name: 'product_data_damaged_products',
        component: () => import('@src/product-data/damaged-products/damaged-products'),
        meta: {
            title: 'B-Ware',
            role: 'ROLE_SHOW_DAMAGED_PRODUCT',
        },
    },
    {
        path: '/product-data/damaged-products/:id',
        name: 'product_data_damaged_products_edit',
        component: () => import('@src/product-data/damaged-products/edit-damaged-product'),
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'B-Ware',
            role: 'ROLE_EDIT_DAMAGED_PRODUCT',
        },
    },
    {
        path: '/product-data/attribute',
        name: 'product_data_attribute',
        component: () => import('@src/product-data/attribute/attribute-list.vue'),
        meta: {
            title: 'Attribute',
            role: 'ROLE_SHOW_ATTRIBUTE',
        },
    },
    {
        path: '/product-data/attribute-group',
        name: 'product_data_attribute_group',
        component: () => import('@src/product-data/attribute-group/list.vue'),
        meta: {
            title: 'Attribut-Gruppen',
            role: 'ROLE_LIST_ATTRIBUTE_GROUP',
        },
    },
    {
        path: '/product-data/attribute/edit/:id',
        name: 'product_data_attribute_edit',
        component: () => import('@src/product-data/attribute/attribute.vue'),
        meta: {
            title: 'Attribut bearbeiten',
            role: 'ROLE_EDIT_ATTRIBUTE',
        },
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);
            return props;
        },
    },
    {
        path: '/product-data/attribute/create',
        name: 'product_data_attribute_create',
        component: () => import('@src/product-data/attribute/attribute.vue'),
        meta: {
            title: 'Attribut erstellen',
            role: 'ROLE_EDIT_ATTRIBUTE',
        },
    },
    {
        path: '/product-data/attribute-group/edit/:id',
        name: 'product_data_attribute_group_edit',
        component: () => import('@src/product-data/attribute-group/attribute-group.vue'),
        meta: {
            title: 'Attribut-Gruppe bearbeiten',
            role: 'ROLE_EDIT_ATTRIBUTE_GROUP',
        },
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
    },
    {
        path: '/product-data/attribute-group/create',
        name: 'product_data_attribute_group_create',
        component: () => import('@src/product-data/attribute-group/attribute-group.vue'),
        meta: {
            title: 'Attribut-Gruppe erstellen',
            role: 'ROLE_EDIT_ATTRIBUTE_GROUP',
        },
    },
    {
        path: '/product-group/list',
        name: 'product_group_list',
        component: () => import('@src/product-data/product-group/product-group-list'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Produktgruppen',
            role: 'ROLE_LIST_PRODUCT_GROUP',
        },
    },
    {
        path: '/product-group/create',
        name: 'product_group_create',
        component: () => import('@src/product-data/product-group/product-group.vue'),
        meta: {
            title: 'Produktgruppe erstellen',
            role: 'ROLE_EDIT_PRODUCT_GROUP',
        },
    },
    {
        path: '/product-group/edit/:id',
        name: 'product_group_edit',
        component: () => import('@src/product-data/product-group/product-group.vue'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Produktgruppe bearbeiten',
            role: 'ROLE_EDIT_PRODUCT_GROUP',
        },
    },
    {
        path: '/product-kind/list',
        name: 'product_kind_list',
        component: () => import('@src/product-data/product-kind/product-kind-list'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Produktarten',
            role: 'ROLE_LIST_PRODUCT_KIND',
        },
    },
    {
        path: '/product-kind/create',
        name: 'product_kind_create',
        component: () => import('@src/product-data/product-kind/product-kind.vue'),
        meta: {
            title: 'Produktart erstellen',
            role: 'ROLE_EDIT_PRODUCT_KIND',
        },
    },
    {
        path: '/product-kind/edit/:id',
        name: 'product_kind_edit',
        component: () => import('@src/product-data/product-kind/product-kind.vue'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Produktart bearbeiten',
            role: 'ROLE_EDIT_PRODUCT_KIND',
        },
    },
    {
        path: '/product-data/reports/products-missing-show-in-shop/:filter?',
        name: 'product_data_reports_products_missing_show_in_shop',
        component: () => import('@src/product-data/pim/products-missing-show-in-shop'),
        meta: {
            title: 'Nicht angezeigte Produkte',
            role: 'ROLE_SHOW_PIM_REPORTS',
        },
    },
    {
        path: '/product-data/reports/products-missing-category/:filter?',
        name: 'product_data_reports_products_missing_category',
        component: () => import('@src/product-data/pim/products-missing-category'),
        meta: {
            title: 'Produkte ohne Kategorie',
            role: 'ROLE_SHOW_PIM_REPORTS',
        },
    },
    {
        path: '/product-data/reports/products-media-reference-error/:filter?',
        name: 'product_data_reports_media_reference_error',
        component: () => import('@src/product-data/pim/products-media-reference-error'),
        meta: {
            title: 'Media Referenz Fehler',
            role: 'ROLE_SHOW_PIM_REPORTS',
        },
    },
    {
        path: '/product-data/project/create',
        name: 'product_data_project_create',
        component: () => import('@src/product-data/project/pim-project-create'),
        meta: {
            title: 'Projekt anlegen',
            role: 'ROLE_EDIT_PIM_PROJECT',
        },
    },
    {
        path: '/product-data/project/edit/:id',
        name: 'product_data_project_edit',
        component: () => import('@src/product-data/project/pim-project-edit'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Projekt bearbeiten',
            role: 'ROLE_EDIT_PIM_PROJECT',
        },
    },
    {
        path: '/product-data/bulk-price-edit/:filter?',
        name: 'product_data_bulk_price_edit',
        component: () => import('@src/product-data/bulk-price-edit/product-list'),
        meta: {
            title: 'Bulkbearbeitung EK & UVP',
            role: 'ROLE_BULK_PRICE_EDIT',
        },
    },
    {
        path: '/product-data/shipment-product-group/overview',
        name: 'shipment_product_group_overview',
        component: () => import('@src/product-data/shipment-product-group/shipment-product-group-overview'),
        meta: {
            title: 'Versandgruppen',
            role: 'ROLE_LIST_SHIPMENT_PRODUCT_GROUP',
        },
    },
    {
        path: '/product-data/shipment-product-group/products-without-group',
        name: 'shipment_product_group_products_without_group',
        component: () => import('@src/product-data/shipment-product-group/products-without-group-list'),
        meta: {
            title: 'Produkte ohne Versandgruppe',
            role: 'ROLE_LIST_SHIPMENT_PRODUCT_GROUP',
        },
    },
    {
        path: '/product-data/reported-products/list',
        name: 'reported_products_list',
        component: () => import('@src/product-data/reported-products/list'),
        meta: {
            title: 'Gemeldete Produkte',
            role: 'ROLE_REPORTED_PRODUCTS_LIST',
        },
    },
    {
        path: '/product-data/reported-products/detail/:id',
        name: 'reported_products_detail',
        component: () => import('@src/product-data/reported-products/detail'),
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Gemeldetes Produkt',
            role: 'ROLE_REPORTED_PRODUCTS_LIST',
        },
    },
    {
        path: '/product-data/shipment-product-group/create',
        name: 'shipment_product_group_create',
        component: () => import('@src/product-data/shipment-product-group/shipment-product-group.vue'),
        meta: {
            title: 'Versandgruppe anlegen',
            role: 'ROLE_EDIT_SHIPMENT_PRODUCT_GROUP',
        },
    },
    {
        path: '/product-data/shipment-product-group/edit/:id',
        name: 'shipment_product_group_edit',
        component: () => import('@src/product-data/shipment-product-group/shipment-product-group.vue'),
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Versandgruppe bearbeiten',
            role: 'ROLE_EDIT_SHIPMENT_PRODUCT_GROUP',
        },
    },
];
